import { useSelector } from "react-redux";

import { ComponentCommunityEventDetail } from "@components";
import { selectAuth } from "@redux";


export const PageCommunityEventDetail = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentCommunityEventDetail
            memberTier={memberTier} avatar={""} fullName={""} socials={[]} />
    );
};
